<template src="./index.html">
</template>
<script>
	import {
		getdata
	} from './data.js'
	export default {
		name: '',
		components: {},
		data: function() {
			return {
				headDataI: getdata().headDataI,
				// headDataII: getdata().headDataII,
				options: [{
						value: "0061064002|国家重大水利工程建设基金免征教育费附加|《财政部 国家税务总局关于免征国家重大水利工程建设基金的城市维护建设税和教育费附加的通知》 财税〔2010〕44号"
					},
					{
						value: "0061013608|建档立卡贫困人口从事个体经营扣减教育费附加|《财政部 税务总局 人力资源社会保障部 国务院扶贫办关于进一步支持和促进重点群体创业就业有关税收政策的通知》 财税〔2019〕22号第一条"
					},
					{
						value: "0061011804|企业招用退役士兵扣减教育费附加优惠|《财政部 税务总局 退役军人部关于进一步扶持自主就业退役士兵创业就业有关税收政策的通知》 财税〔2019〕21号第二条"
					},
					{
						value: "0061042802|按月纳税的月销售额或营业额不超过10万元缴纳义务人免征教育费附加|《财政部 国家税务总局关于扩大有关政府性基金免征范围的通知》 财税〔2016〕12号第一条"
					},
					{
						value: "0061011803|退役士兵从事个体经营扣减教育费附加优惠|《财政部 税务总局 退役军人部关于进一步扶持自主就业退役士兵创业就业有关税收政策的通知》 财税〔2019〕21号第一条"
					},
					{
						value: "0061129999|高校毕业生从事个体经营，扣减教育费附加|其他"
					},
					{
						value: "0061129999|上海期货交易所会员和客户通过上海期货交易所销售标准黄金,发生实物交割并已出库的，免征教育费附加|其他"
					},
					{
						value: "0061129999|除高校毕业生以外的失业人员从事个体经营，扣减教育费附加|其他"
					},
					{
						value: "0061129999|被撤销金融机构清偿债务免征教育费附加|其他"
					},
					{
						value: "0061129999|其他|其他"
					},
					{
						value: "0061129999|安置自谋职业的城镇退役士兵企业免征教育费附加|其他"
					},
					{
						value: "0061013609|登记失业半年以上人员，零就业家庭、享受城市低保登记失业人员，毕业年度内高校毕业生从事个体经营扣减教育费附加|《财政部 税务总局 人力资源社会保障部 国务院扶贫办关于进一步支持和促进重点群体创业就业有关税收政策的通知》 财税〔2019〕22号第一条"
					},
					{
						value: "0061013611|企业招用登记失业半年以上人员，零就业家庭、享受城市低保登记失业人员，毕业年度内高校毕业生就业扣减教育费附加|《财政部 税务总局 人力资源社会保障部 国务院扶贫办关于进一步支持和促进重点群体创业就业有关税收政策的通知》 财税〔2019〕22号第二条"
					},
					{
						value: "0061013610|企业招用建档立卡贫困人口就业扣减教育费附加|《财政部 税务总局 人力资源社会保障部 国务院扶贫办关于进一步支持和促进重点群体创业就业有关税收政策的通知》 财税〔2019〕22号第二条"
					}
				],
				"cswhjs": [{
						"jianmxzdm": "0007011803",
						"shuiwsxdm": "SXA031901031",
						"shuiwsxmc": "退役士兵从事个体经营扣减城市维护建设税优惠",
						"jianmsxmc": "《财政部税务总局退役军人事务部关于进一步扶持自主就业退役士兵创业就业有关税收政策的公告》财政部税务总局退役军人事务部公告2023年第14号第一条"
					},
					{
						"jianmxzdm": "0007011804",
						"shuiwsxdm": "SXA031901032",
						"shuiwsxmc": "企业招用退役士兵扣减城市维护建设税优惠",
						"jianmsxmc": "《财政部税务总局退役军人事务部关于进一步扶持自主就业退役士兵创业就业有关税收政策的公告》财政部税务总局退役军人事务部公告2023年第14号第二条"
					},
					{
						"jianmxzdm": "0007013610",
						"shuiwsxdm": "SXA031901040",
						"shuiwsxmc": "脱贫人口从事个体经营扣减城市维护建设税",
						"jianmsxmc": "《财政部税务总局人力资源社会保障部农业农村部关于进一步支持重点群体创业就业有关税收政策的公告》财政部税务总局人力资源社会保障部农业农村部公告2023年第15号第一条"
					},
					{
						"jianmxzdm": "0007013611",
						"shuiwsxdm": "SXA031901023",
						"shuiwsxmc": "登记失业半年以上人员，零就业家庭、享受城市低保登记失业人员，毕业年度内高校毕业生从事个体经营扣减城市维护建设税",
						"jianmsxmc": "《财政部税务总局人力资源社会保障部农业农村部关于进一步支持重点群体创业就业有关税收政策的公告》财政部税务总局人力资源社会保障部农业农村部公告2023年第15号第一条"
					},
					{
						"jianmxzdm": "0007013612",
						"shuiwsxdm": "SXA031901041",
						"shuiwsxmc": "企业招用脱贫人口就业扣减城市维护建设税",
						"jianmsxmc": "《财政部税务总局人力资源社会保障部农业农村部关于进一步支持重点群体创业就业有关税收政策的公告》财政部税务总局人力资源社会保障部农业农村部公告2023年第15号第二条"
					},
					{
						"jianmxzdm": "0007013613",
						"shuiwsxdm": "SXA031901024",
						"shuiwsxmc": "企业招用登记失业半年以上人员，零就业家庭、享受城市低保登记失业人员，毕业年度内高校毕业生就业扣减城市维护建设税",
						"jianmsxmc": "《财政部税务总局人力资源社会保障部农业农村部关于进一步支持重点群体创业就业有关税收政策的公告》财政部税务总局人力资源社会保障部农业农村部公告2023年第15号第二条"
					},
					{
						"jianmxzdm": "0007064002",
						"shuiwsxdm": "SXA031900212",
						"shuiwsxmc": "国家重大水利工程建设基金免征城市维护建设税",
						"jianmsxmc": "《财政部国家税务总局关于免征国家重大水利工程建设基金的城市维护建设税和教育费附加的通知》财税〔2010〕44号"
					},
					{
						"jianmxzdm": "0007129999",
						"shuiwsxdm": "SXA031999999",
						"shuiwsxmc": "其他",
						"jianmsxmc": "其他"
					},
					{
						"jianmxzdm": "0007129999",
						"shuiwsxdm": "SXA031900603",
						"shuiwsxmc": "促进就业企业限额减免城市维护建设税",
						"jianmsxmc": "其他"
					},
					{
						"jianmxzdm": "0007129999",
						"shuiwsxdm": "SXA031900409",
						"shuiwsxmc": "受灾地区促进就业企业限额减免城市维护建设税",
						"jianmsxmc": "其他"
					},
					{
						"jianmxzdm": "0007129999",
						"shuiwsxdm": "SXA031900609",
						"shuiwsxmc": "金融资产管理公司收购、承接、处置不良资产免征城市维护建设税",
						"jianmsxmc": "其他"
					},
					{
						"jianmxzdm": "0007129999",
						"shuiwsxdm": "SXA031900602",
						"shuiwsxmc": "被撤销金融机构财产用来清偿债务免征城市维护建设税",
						"jianmsxmc": "其他"
					},
					{
						"jianmxzdm": "0007129999",
						"shuiwsxdm": "SXA031900610",
						"shuiwsxmc": "上海期货交易所会员和客户通过上海期货交易所销售标准黄金,发生实物交割并已出库的，免征城市维护建设税",
						"jianmsxmc": "其他"
					},
					{
						"jianmxzdm": "0007129999",
						"shuiwsxdm": "SXA031900608",
						"shuiwsxmc": "黄金交易所会员单位免征城市维护建设税",
						"jianmsxmc": "其他"
					},
					{
						"jianmxzdm": "0007129999",
						"shuiwsxdm": "SXA031900598",
						"shuiwsxmc": "对国家石油储备基地第一期项目建设过程中涉及的城市维护建设税，予以免征",
						"jianmsxmc": "其他"
					},
					{
						"jianmxzdm": "0007129999",
						"shuiwsxdm": "SXA031900599",
						"shuiwsxmc": "文化单位转制为企业时的城市维护建设税优惠",
						"jianmsxmc": "其他"
					},
					{
						"jianmxzdm": "6107010506",
						"shuiwsxdm": "61A031005006",
						"shuiwsxmc": "自主就业退役士兵创业优惠城建税",
						"jianmsxmc": "《陕西省财政厅等四部门转发财政部国家税务总局民政部关于调整完善扶持自主就业退役士兵创业就业有关税收政策的通知》（陕财税〔2014〕11号）"
					},
					{
						"jianmxzdm": "6107010512",
						"shuiwsxdm": "61A031005012",
						"shuiwsxmc": "重点群体就业优惠城建税",
						"jianmsxmc": "《陕西省关于继续实施支持和促进重点群体创业就业有关税收政策的通知》陕财税【2014】14号"
					}
				],
				"dfjyfj": [{
						"jianmxzdm": "0061064002",
						"shuiwsxdm": "SXA031900213",
						"shuiwsxmc": "国家重大水利工程建设基金免征教育费附加",
						"jianmsxmc": "《财政部国家税务总局关于免征国家重大水利工程建设基金的城市维护建设税和教育费附加的通知》财税〔2010〕44号"
					},
					{
						"jianmxzdm": "5163064001",
						"shuiwsxdm": "51A031005003",
						"shuiwsxmc": "国家重大水利工程建设基金免征地方教育附加",
						"jianmsxmc": "《四川省人民政府关于印发四川省地方教育附加征收使用管理办法的通知》川府函〔2011〕68号第九条"
					},
					{
						"jianmxzdm": "6463032405",
						"shuiwsxdm": "64A031005024",
						"shuiwsxmc": "对卷烟厂和经营烟叶的单位，减半征收地方教育费附加",
						"jianmsxmc": "《宁夏回族自治区地方教育附加征收使用管理办法》（宁财（综）发〔2007〕765号）第十条第2项"
					},
					{
						"jianmxzdm": "5063013601",
						"shuiwsxdm": "50A031005004",
						"shuiwsxmc": "城镇移民从事个体经营限额减免地方教育附加费",
						"jianmsxmc": "重庆市地方税务局贯彻落实《重庆市人民政府办公厅关于发挥财税职能缩小三个差距的实施意见》的通知（渝地税发〔2011〕215号）"
					},
					{
						"jianmxzdm": "0001011813",
						"shuiwsxdm": "SXA031M00008",
						"shuiwsxmc": "退役士兵从事个体经营扣减地方教育附加优惠",
						"jianmsxmc": "《财政部税务总局退役军人事务部关于进一步扶持自主就业退役士兵创业就业有关税收政策的公告》财政部税务总局退役军人事务部公告2023年第14号第一条"
					},
					{
						"jianmxzdm": "0099011706",
						"shuiwsxdm": "SXA031901333",
						"shuiwsxmc": "保障性住房项目免收各项行政事业性收费和政府性基金",
						"jianmsxmc": "《财政部税务总局住房城乡建设部关于保障性住房有关税费政策的公告》财政部税务总局住房城乡建设部公告2023年第70号第五条"
					},
					{
						"jianmxzdm": "0061064002",
						"shuiwsxdm": "SXA031900213",
						"shuiwsxmc": "国家重大水利工程建设基金免征教育费附加",
						"jianmsxmc": "《财政部国家税务总局关于免征国家重大水利工程建设基金的城市维护建设税和教育费附加的通知》财税〔2010〕44号"
					},
					{
						"jianmxzdm": "0099021901",
						"shuiwsxdm": "SXA031900192",
						"shuiwsxmc": "光伏发电免征政府性基金",
						"jianmsxmc": "《财政部关于对分布式光伏发电自发自用电量免征政府性基金有关问题的通知》财综〔2013〕103号"
					},
					{
						"jianmxzdm": "0099129999",
						"shuiwsxdm": "SXA031999999",
						"shuiwsxmc": "其他",
						"jianmsxmc": "其他"
					},
					{
						"jianmxzdm": "0061042802",
						"shuiwsxdm": "SXA031900783",
						"shuiwsxmc": "按月纳税的月销售额或营业额不超过10万元缴纳义务人免征教育费附加",
						"jianmsxmc": "《财政部国家税务总局关于扩大有关政府性基金免征范围的通知》财税〔2016〕12号第一条"
					},
					{
						"jianmxzdm": "0099013601",
						"shuiwsxdm": "SXA031901044",
						"shuiwsxmc": "脱贫人口从事个体经营扣减地方教育附加",
						"jianmsxmc": "《财政部税务总局人力资源社会保障部农业农村部关于进一步支持重点群体创业就业有关税收政策的公告》财政部税务总局人力资源社会保障部农业农村部公告2023年第15号第一条"
					},
					{
						"jianmxzdm": "0099013602",
						"shuiwsxdm": "SXA031901027",
						"shuiwsxmc": "登记失业半年以上人员，零就业家庭、享受城市低保登记失业人员，毕业年度内高校毕业生从事个体经营扣减地方教育附加",
						"jianmsxmc": "《财政部税务总局人力资源社会保障部农业农村部关于进一步支持重点群体创业就业有关税收政策的公告》财政部税务总局人力资源社会保障部农业农村部公告2023年第15号第一条"
					},
					{
						"jianmxzdm": "0099013603",
						"shuiwsxdm": "SXA031901045",
						"shuiwsxmc": "企业招用脱贫人口就业扣减地方教育附加",
						"jianmsxmc": "《财政部税务总局人力资源社会保障部农业农村部关于进一步支持重点群体创业就业有关税收政策的公告》财政部税务总局人力资源社会保障部农业农村部公告2023年第15号第二条"
					},
					{
						"jianmxzdm": "0099013604",
						"shuiwsxdm": "SXA031901028",
						"shuiwsxmc": "企业招用登记失业半年以上人员，零就业家庭、享受城市低保登记失业人员，毕业年度内高校毕业生就业扣减地方教育附加",
						"jianmsxmc": "《财政部税务总局人力资源社会保障部农业农村部关于进一步支持重点群体创业就业有关税收政策的公告》财政部税务总局人力资源社会保障部农业农村部公告2023年第15号第二条"
					},
					{
						"jianmxzdm": "0099011801",
						"shuiwsxdm": "SXA031901035",
						"shuiwsxmc": "退役士兵从事个体经营扣减地方教育附加优惠",
						"jianmsxmc": "《财政部税务总局退役军人事务部关于进一步扶持自主就业退役士兵创业就业有关税收政策的公告》财政部税务总局退役军人事务部公告2023年第14号第一条"
					},
					{
						"jianmxzdm": "0099011802",
						"shuiwsxdm": "SXA031901036",
						"shuiwsxmc": "企业招用退役士兵扣减地方教育附加优惠",
						"jianmsxmc": "《财政部税务总局退役军人事务部关于进一步扶持自主就业退役士兵创业就业有关税收政策的公告》财政部税务总局退役军人事务部公告2023年第14号第二条"
					},
					{
						"jianmxzdm": "0099042802",
						"shuiwsxdm": "SXA031901054",
						"shuiwsxmc": "除小规模纳税人外月（季）销售额小于10（30）万元免征地方教育附加",
						"jianmsxmc": "《财政部国家税务总局关于扩大有关政府性基金免征范围的通知》财税〔2016〕12号第一条第（一）款"
					}
				],
				"jyffj": [{
						"jianmxzdm": "6161010507",
						"shuiwsxdm": "61A031005007",
						"shuiwsxmc": "自主就业退役士兵创业优惠教育费附加",
						"jianmsxmc": "《陕西省财政厅等四部门转发财政部国家税务总局民政部关于调整完善扶持自主就业退役士兵创业就业有关税收政策的通知》（陕财税〔2014〕11号）"
					},
					{
						"jianmxzdm": "6161010513",
						"shuiwsxdm": "61A031005013",
						"shuiwsxmc": "重点群体就业优惠教育费附加",
						"jianmsxmc": "《陕西省关于继续实施支持和促进重点群体创业就业有关税收政策的通知》陕财税【2014】14号"
					},
					{
						"jianmxzdm": "5061013601",
						"shuiwsxdm": "50A031005003",
						"shuiwsxmc": "三峡库区移民从事个体经营限额减免教育附加费",
						"jianmsxmc": "重庆市地方税务局贯彻落实《重庆市人民政府办公厅关于发挥财税职能缩小三个差距的实施意见》的通知（渝地税发〔2011〕215号）"
					},
					{
						"jianmxzdm": "0001011813",
						"shuiwsxdm": "SXA031M00007",
						"shuiwsxmc": "退役士兵从事个体经营扣减教育费附加优惠",
						"jianmsxmc": "《财政部税务总局退役军人事务部关于进一步扶持自主就业退役士兵创业就业有关税收政策的公告》财政部税务总局退役军人事务部公告2023年第14号第一条"
					},
					{
						"jianmxzdm": "6361032401",
						"shuiwsxdm": "63A031003004",
						"shuiwsxmc": "开发区内各类投资企业5年内免征教育费附加",
						"jianmsxmc": "《青海省人民政府关于印发西宁经济技术开发区招商引资优惠政策的通知》（青政[2001]34号）第六条"
					},
					{
						"jianmxzdm": "0061011701",
						"shuiwsxdm": "SXA031901333",
						"shuiwsxmc": "保障性住房项目免收各项行政事业性收费和政府性基金",
						"jianmsxmc": "《财政部税务总局住房城乡建设部关于保障性住房有关税费政策的公告》财政部税务总局住房城乡建设部公告2023年第70号第五条"
					},
					{
						"jianmxzdm": "0061011803",
						"shuiwsxdm": "SXA031901033",
						"shuiwsxmc": "退役士兵从事个体经营扣减教育费附加优惠",
						"jianmsxmc": "《财政部税务总局退役军人事务部关于进一步扶持自主就业退役士兵创业就业有关税收政策的公告》财政部税务总局退役军人事务部公告2023年第14号第一条"
					},
					{
						"jianmxzdm": "0061011804",
						"shuiwsxdm": "SXA031901034",
						"shuiwsxmc": "企业招用退役士兵扣减教育费附加优惠",
						"jianmsxmc": "《财政部税务总局退役军人事务部关于进一步扶持自主就业退役士兵创业就业有关税收政策的公告》财政部税务总局退役军人事务部公告2023年第14号第二条"
					},
					{
						"jianmxzdm": "0061013608",
						"shuiwsxdm": "SXA031901042",
						"shuiwsxmc": "脱贫人口从事个体经营扣减教育费附加",
						"jianmsxmc": "《财政部税务总局人力资源社会保障部农业农村部关于进一步支持重点群体创业就业有关税收政策的公告》财政部税务总局人力资源社会保障部农业农村部公告2023年第15号第一条"
					},
					{
						"jianmxzdm": "0061013609",
						"shuiwsxdm": "SXA031901025",
						"shuiwsxmc": "登记失业半年以上人员，零就业家庭、享受城市低保登记失业人员，毕业年度内高校毕业生从事个体经营扣减教育费附加",
						"jianmsxmc": "《财政部税务总局人力资源社会保障部农业农村部关于进一步支持重点群体创业就业有关税收政策的公告》财政部税务总局人力资源社会保障部农业农村部公告2023年第15号第一条"
					},
					{
						"jianmxzdm": "0061013610",
						"shuiwsxdm": "SXA031901043",
						"shuiwsxmc": "企业招用脱贫人口就业扣减教育费附加",
						"jianmsxmc": "《财政部税务总局人力资源社会保障部农业农村部关于进一步支持重点群体创业就业有关税收政策的公告》财政部税务总局人力资源社会保障部农业农村部公告2023年第15号第二条"
					},
					{
						"jianmxzdm": "0061013611",
						"shuiwsxdm": "SXA031901026",
						"shuiwsxmc": "企业招用登记失业半年以上人员，零就业家庭、享受城市低保登记失业人员，毕业年度内高校毕业生就业扣减教育费附加",
						"jianmsxmc": "《财政部税务总局人力资源社会保障部农业农村部关于进一步支持重点群体创业就业有关税收政策的公告》财政部税务总局人力资源社会保障部农业农村部公告2023年第15号第二条"
					},
					{
						"jianmxzdm": "0061042802",
						"shuiwsxdm": "SXA031900783",
						"shuiwsxmc": "按月纳税的月销售额或营业额不超过10万元缴纳义务人免征教育费附加",
						"jianmsxmc": "《财政部国家税务总局关于扩大有关政府性基金免征范围的通知》财税〔2016〕12号第一条"
					},
					{
						"jianmxzdm": "0061064002",
						"shuiwsxdm": "SXA031900213",
						"shuiwsxmc": "国家重大水利工程建设基金免征教育费附加",
						"jianmsxmc": "《财政部国家税务总局关于免征国家重大水利工程建设基金的城市维护建设税和教育费附加的通知》财税〔2010〕44号"
					},
					{
						"jianmxzdm": "0061129999",
						"shuiwsxdm": "SXA031999999",
						"shuiwsxmc": "其他",
						"jianmsxmc": "其他"
					},
					{
						"jianmxzdm": "0061129999",
						"shuiwsxdm": "SXA031900066",
						"shuiwsxmc": "单位和个体经营者将货物捐赠给受灾地区的免征教育费附加",
						"jianmsxmc": "其他"
					},
					{
						"jianmxzdm": "0061129999",
						"shuiwsxdm": "SXA031900687",
						"shuiwsxmc": "上海期货交易所会员和客户通过上海期货交易所销售标准黄金,发生实物交割并已出库的，免征教育费附加",
						"jianmsxmc": "其他"
					},
					{
						"jianmxzdm": "0061129999",
						"shuiwsxdm": "SXA031900686",
						"shuiwsxmc": "高校毕业生从事个体经营，扣减教育费附加",
						"jianmsxmc": "其他"
					},
					{
						"jianmxzdm": "0061129999",
						"shuiwsxdm": "SXA031900685",
						"shuiwsxmc": "除高校毕业生以外的失业人员从事个体经营，扣减教育费附加",
						"jianmsxmc": "其他"
					},
					{
						"jianmxzdm": "0061129999",
						"shuiwsxdm": "SXA031900016",
						"shuiwsxmc": "安置自谋职业的城镇退役士兵企业免征教育费附加",
						"jianmsxmc": "其他"
					},
					{
						"jianmxzdm": "0061129999",
						"shuiwsxdm": "SXA031900681",
						"shuiwsxmc": "被撤销金融机构清偿债务免征教育费附加",
						"jianmsxmc": "其他"
					}
				]
			};
		},
		props: {
			toseeUpdate: {
				type: Boolean,
				default: false
			},
			showpz: {
				type: Boolean,
				default: false
			},
			tableDataI: {
				type: Array,
				default: [],
			},
			tableDataII: {
				type: Array,
				default: [],
			},
			// tableDataIII: {
			// 	type: Array,
			// 	default: [],
			// },
			headobj: {
				type: Object,
				default: {},
			},
			choosecellCode: {
				type: String,
				default: ""
			},
			type: {
				type: String,
				default: ""
			},
		},
		created() {},
		methods: {
			inputblur(e) {
				this.$emit("inputblur", e)
			},
			zcsclick(e) {
				this.$emit("zcsclick", e)
			},
			forhover(table, colum, index) {
				this.$emit("forhover", table, colum, index)
			},
			headercellstyle({
				row,
				column,
				rowIndex,
				columnIndex
			}) {
				if (rowIndex === 0) {
					if (columnIndex === 0) {
						this.$nextTick(() => {
							if (document.getElementsByClassName(column.id).length !== 0) {
								document
									.getElementsByClassName(column.id)[0]
									.setAttribute('colSpan', 2);
							}
						});
					}
					if (columnIndex === 1) {
						return {
							display: "none"
						};
					}
					if (columnIndex === 3 || columnIndex === 4 || columnIndex === 9 || columnIndex === 10) {
						this.$nextTick(() => {
							if (document.getElementsByClassName(column.id).length !== 0) {
								document
									.getElementsByClassName(column.id)[0]
									.setAttribute('rowSpan', 2);
							}
						});
					}
				}
				if (rowIndex === 1) {
					if (columnIndex === 4 || columnIndex === 5 || columnIndex === 14 || columnIndex === 15) {
						return {
							display: "none"
						};
					}
				}
			},
		}
	};
</script>


<style scoped lang="less">
	@import url('./index.less');
	@import url('../../SalesTaxReport/index.less');
</style>